module.exports = __webpack_public_path__ + "static/media/close_Icon.0d60bb35.svg";